import { render, staticRenderFns } from "./Pivot.vue?vue&type=template&id=61be913e&scoped=true"
import script from "./Pivot.vue?vue&type=script&lang=js"
export * from "./Pivot.vue?vue&type=script&lang=js"
import style0 from "./Pivot.vue?vue&type=style&index=0&id=61be913e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61be913e",
  null
  
)

export default component.exports